// Public Eurolabs Stream assets imported and verified on 2026-09-16. No credentials.
// Source paths remain stable lookup keys; original files stay available for rollback.
const STREAM_ORIGIN = "https://customer-33tv3m84qpsbb1kd.cloudflarestream.com";

function streamVideo(id: string) {
	return {
		src: `${STREAM_ORIGIN}/${id}/downloads/default.mp4`,
		poster: `${STREAM_ORIGIN}/${id}/thumbnails/thumbnail.jpg?width=640`,
	};
}

export const CLOUDFLARE_STREAM_VIDEOS: Readonly<Record<string, { src: string; poster: string }>> = {
	"/hero-videos/synthese.mp4": streamVideo("e97873972424ef9c152321e25d1bc412"),
	"/hero-videos/drittlabor.mp4": streamVideo("8e9d81d796b21d9c540de12fddc0f1f6"),
	"/hero-videos/kuehlkette.mp4": streamVideo("cfe9607ab6d741a98c1576b1630cb655"),
	"/hero-videos/katalog.mp4": streamVideo("9bf3f25eafbf36210fa21f3f7ccee80c"),
	"/wirkstoff-hero/molecules.mp4": streamVideo("4c5c8ad57f5e5bfa01507558a658c40c"),
	"/wirkstoff-hero/pipetting.mp4": streamVideo("e007f55656b892ba310967c23484c705"),
	"/wirkstoff-hero/lab-tools.mp4": streamVideo("b34551b716e6bde5a2895562d4f48639"),
	"/wirkstoff-hero/science.mp4": streamVideo("65b486b840a54b09e3d54302d7b9033a"),
	"/wirkstoff-hero/applications.mp4": streamVideo("9359095b728e1f7a283dcd56b5086eb0"),
	"/wirkstoff-hero/partnerships.mp4": streamVideo("eb233d21bfafff8d6f6a4d152a58cedd"),
};
